import { render } from "./PickingManagement.vue?vue&type=template&id=6fd3e830"
import script from "./PickingManagement.vue?vue&type=script&lang=js"
export * from "./PickingManagement.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__